<template>
    <div>
        <edit-about-us-modal
            v-model="show_about_us_dialog"
            :modelProp="contents.about_us"
            :constants="constants"
        />
        <edit-content-modal
            :activeOptions="['main_image', 'documents']"
            v-model="show_steps_dialog"
            :modelProp="contents.steps_to_join"
            :constants="constants"
        />

        <edit-history-dialog
            v-model="show_history_dialog"
            :modelProp="selected_history"
            @successful-history-save="refreshHistoryData"
            @successful-history-delete="refreshHistoryData"
            :constants="constants"
        />

        <edit-board-member-dialog
            v-model="show_board_member_dialog"
            :modelProp="selected_board_member"
            @successful-save="refreshBoardMemberData"
            @successful-delete="refreshBoardMemberData"
            :constants="constants"
        />

        <edit-member-at-large-dialog
            v-model="show_member_at_large_dialog"
            :modelProp="selected_member_at_large"
            @successful-save="refreshMemberAtLargeData"
            @successful-delete="refreshMemberAtLargeData"
            :constants="constants"
        />

        <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                <internal-table-section section-title="About Us" button-text="Edit About us" @button-clicked="editAboutUs" class="tw-w-full lg:tw-w-1/2">
                    <v-card id="table_about_us_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <v-layout child-flex>
                                {{ $root.sanitizeAndTruncateHTML(contents.about_us.body, 600) }}
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </internal-table-section>
                <internal-table-section section-title="Steps To Join" button-text="Edit Steps" @button-clicked="editSteps" class="tw-w-full lg:tw-w-1/2">
                    <v-card id="table_steps_to_join_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <v-layout child-flex>
                                {{ $root.sanitizeAndTruncateHTML(contents.steps_to_join.body, 600) }}
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </internal-table-section >
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                <internal-table-section section-title="History" button-text="Add History" @button-clicked="addHistoryItem" class="tw-w-full">
                    <v-card id="table_history_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <v-layout child-flex>
                                    <smart-table
                                        id="table_history"
                                        class="row-pointer"
                                        endpoint="history.list"
                                        :headers="headersHistory"
                                        flat
                                        @click:row="showHistoryItem"
                                        ref="history_list"
                                    >
                                        <template v-slot:item.image_desktop="{ item, isMobile }">
                                            <v-img
                                                v-if="item.image_desktop && !isMobile"
                                                max-height="75"
                                                max-width="100"
                                                :src="'/storage/history/' + item.image_desktop"
                                            ></v-img>
                                            <v-img
                                                v-else-if="item.image_mobile"
                                                max-height="75"
                                                max-width="100"
                                                :src="'/storage/history/' + item.image_mobile"
                                            ></v-img>
                                        </template>
                                    </smart-table>
                                </v-layout>
                        </v-card-text>
                    </v-card>
                </internal-table-section>
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                <internal-table-section section-title="Board Members" button-text="Add Board Member" @button-clicked="addBoardMemberItem" class="tw-w-full lg:tw-w-1/2">
                    <v-card id="table_board_members_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <v-layout child-flex>
                                    <smart-table
                                        id="table_board_members"
                                        class="row-pointer"
                                        endpoint="boardmembers.list"
                                        :headers="headersBoardMembers"
                                        flat
                                        @click:row="showBoardMemberItem"
                                        ref="board_members_list"
                                    >
                                    </smart-table>
                                </v-layout>
                        </v-card-text>
                    </v-card>
                </internal-table-section>
                <internal-table-section section-title="Members at Large" button-text="Add Member" @button-clicked="addMemberAtLargeItem" class="tw-w-full lg:tw-w-1/2">
                    <v-card id="table_members_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <v-layout child-flex>
                                    <smart-table
                                        id="table_members"
                                        class="row-pointer"
                                        endpoint="membersatlarge.list"
                                        :headers="headersMembersAtLarge"
                                        flat
                                        @click:row="showMemberAtLargeItem"
                                        ref="members_list"
                                    >
                                    </smart-table>
                                </v-layout>
                        </v-card-text>
                    </v-card>
                </internal-table-section >
            </div>
        </div>

    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import EditContentModal from "@/Modals/EditContentModal.vue";
    import WYSIWYG from "@/Generic/WYSIWYG";
    import EditHistoryDialog from "@/Modals/EditHistoryDialog.vue";
    import EditBoardMemberDialog from "@/Modals/EditBoardMemberDialog.vue";
    import EditMemberAtLargeDialog from "@/Modals/EditMemberAtLargeDialog.vue";
    import EditAboutUsModal from "@/Modals/EditAboutUsModal";

    export default {
        name: "WebsiteContentAboutUs",
        components: {
            EditAboutUsModal,
            EditMemberAtLargeDialog,
            EditBoardMemberDialog,
            EditHistoryDialog,
            EditContentModal,
            SmartTable,
            InternalHeader,
            InternalTableSection,
            WYSIWYG,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
        },
        data() {
            return {
                selected_about_us: null,
                selected_board_member: null,
                selected_history: null,
                selected_member_at_large: null,
                show_board_member_dialog: false,
                show_history_dialog: false,
                show_member_at_large_dialog: false,
                show_steps_dialog: false,
                show_about_us_dialog: false,
                stepsSelected: this.steps,
                stepObject: {},
            }
        },
        mounted() {
            //
        },
        computed: {
            headersExample() {
                return [
                    {value: 'field_name',    text: 'Field Label',    align: `start`, sortable: false,   filterable: false,   search: null, optional: false },
                ]
            },
            headersHistory() {
                return [
                    {value: 'year',             text: 'Year',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'image_desktop',    text: 'Image',          align: `start`,   sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'image_mobile',     text: 'Image',          align: ` d-none`,   sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'title',            text: 'Title',          align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'body',             text: 'Body',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                ]
            },
            headersBoardMembers() {
                return [
                {value: 'title',            text: 'Title',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                {value: 'name',             text: 'Name',            align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                {value: 'email',            text: 'Email',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                ]
            },
            headersMembersAtLarge() {
                return [
                {value: 'title',            text: 'Title',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                {value: 'name',             text: 'Name',            align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                {value: 'email',            text: 'Email',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                ]
            },
        },
        methods: {
            // Board Member
            refreshBoardMemberData() {
                this.$refs.board_members_list.refreshList()
            },
            showBoardMemberItem(item) {
                this.selected_board_member = item
                this.show_board_member_dialog = true
            },
            addBoardMemberItem() {
                this.selected_board_member = null
                this.show_board_member_dialog = true
            },
            // History
            refreshHistoryData() {
                this.$refs.history_list.refreshList()
            },
            showHistoryItem(item) {
                this.selected_history = item
                this.show_history_dialog = true
            },
            addHistoryItem() {
                this.selected_history = null
                this.show_history_dialog = true
            },
            editSteps() {
                this.stepsSelected = null
                this.show_steps_dialog = true
            },
            editAboutUs(){
                this.selected_about_us = null
                this.show_about_us_dialog = true
            },
            // Member At Large
            refreshMemberAtLargeData() {
                this.$refs.members_list.refreshList()
            },
            showMemberAtLargeItem(item) {
                this.selected_member_at_large = item
                this.show_member_at_large_dialog = true
            },
            addMemberAtLargeItem() {
                this.selected_member_at_large = null
                this.show_member_at_large_dialog = true
            },
        }
    }
</script>
